import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Divider,
} from "@mui/material";
import axiosInstance from "../api/axios";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";


const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { fetchUser } = useContext(AuthContext);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axiosInstance.post(
        "/users/login",
        {
          email: formData.email,
          password: formData.password
        },
        {
          headers: {
            "Content-Type": "application/json"
          },  withCredentials: true 
        }
      );
      console.log(response);
      await fetchUser();
      navigate("/");

      // localStorage.setItem("token", response.data.access_token);
    } catch (err) {
      setError("אימייל או סיסמה אינם נכונים.");
    }
  };

  const onSuccess = async (credentialResponse) => {
    try {
      const response = await axiosInstance.post("/users/google-login", {
        token: credentialResponse.credential,
      },{ withCredentials: true } 
    );
    console.log(response);
    await fetchUser();

      // localStorage.setItem("token", response.data.access_token);
      navigate("/");
    } catch (error) {
      setError("אירעה שגיאה בהתחברות דרך Google.");
    }
  };

  const onError = () => {
    setError("התחברות דרך Google נכשלה.");
  };

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Box
        sx={{
          maxWidth: "400px",
          margin: "auto",
          mt: 5,
          padding: "20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          backgroundColor: "white",
          textAlign: "center",
          // RTL (ימין לשמאל)
          direction: "rtl",
        }}
      >
        <Typography variant="h4" gutterBottom>
          התחברות
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="אימייל"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            margin="normal"
            inputProps={{ style: { textAlign: "right" } }}
          />
          <TextField
            fullWidth
            type="password"
            label="סיסמה"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            margin="normal"
            inputProps={{ style: { textAlign: "right" } }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#1976d2" }}
          >
            התחבר
          </Button>
        </form>

        <Typography variant="body2" sx={{ mt: 2 }}>
        <Link
    to="/reset-password"
    style={{ color: "#1976d2", textDecoration: "none" }}
  >
    שכחת סיסמה?
  </Link>
        </Typography>

        <Divider sx={{ my: 2 }}>או</Divider>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <GoogleLogin
            onSuccess={onSuccess}
            onError={onError}
            theme="filled_blue"
            shape="pill"
            text="continue_with"
            style={{
              marginTop: "20px",
              width: "240px",
              height: "40px",
            }}
          />
        </Box>

        <Typography variant="body2" sx={{ mt: 3, color: "gray" }}>
          אין לך חשבון?{" "}
          <a
            href="/register"
            style={{ color: "#1976d2", textDecoration: "none" }}
          >
            הירשם כאן
          </a>
        </Typography>
      </Box>
    </GoogleOAuthProvider>
  );
};

export default Login;
